export const isIE = () => { // 判断IE11以下的浏览器（不包括IE11）
  if (window.navigator.userAgent.indexOf("MSIE") >= 1) return true;
  else return false;
}

// 是否为mac系统（包含iphone手机
export const isMac = () => /macintosh|mac os x/i.test(navigator.userAgent)

export const getDetailRecord = (history, pathname) => {
  const { utils_tool } = require('@/tool')
  const { Session } = utils_tool
  const pathnameArr = pathname.split('/')

  let detailInfo = ''
  const sessionName = pathnameArr[1] + '-' + pathnameArr[pathnameArr.length - 1] + 'Record'
  if (history.location && history.location.pathname === pathname) {
    if (history.location && history.location.record) {
      detailInfo = history.location.record || {}
      Session.add(sessionName, detailInfo)
    } else {
      detailInfo = Session.get(sessionName) || {}
    }
  }
  return detailInfo
}


// 受众组件数据格式化
export const formatAuth = (value = {}) => {
  const _value = {}
  if (value.groupId) {
    if (Array.isArray(value.groupId)) {
      _value.groupId = value.groupId.map(val => val.id).toString()
    } else if (Object.prototype.toString.call(value.groupId) === "[object Object]") {
      _value.groupId = value.groupId.id
    } else {
      console.error('受众字段类型错误: ', value.groupId)
    }
  } else {
    _value.orgIds = value.orgIds && value.orgIds.length ? value.orgIds.map(val => val.id) : []
    _value.personIds = value.personIds && value.personIds.length ? value.personIds.map(val => val.id) : []
    _value.positionCategoryIds = value.positionCategoryIds && value.positionCategoryIds.length ? value.positionCategoryIds.map(val => val.id) : []
    _value.positionIds = value.positionIds && value.positionIds.length ? value.positionIds.map(val => val.id) : []
  }
  return _value
}

// 跳转链接域名拼接
export const getLocationOrgin = () => {
  let { pathname, origin } = window.location
  let url = `${origin}${pathname}`
  let replaceUrl = url.replace(/\/+$/, "")
  return replaceUrl
}